import * as TOPIC from '@/components/trendradar/help/topics'
export default {
    title: 'Assistance',
    [TOPIC.TRENDRADAR]: {
        topic: 'What is a Trend Radar?',
        url: 'https://support.trendmanager.com/en/help-topic/what-is-a-trend-radar/'
    },
    [TOPIC.RECOMMENDATIONS]: {
        topic: 'What do the recommendations for action mean?',
        url: 'https://support.trendmanager.com/en/help-topic/what-do-the-recommendations-for-action-act-prepare-and-watch-mean/'
    },
    [TOPIC.CRITERIA]: {
        topic: 'By which criteria are the trends evaluated?',
        url: 'https://support.trendmanager.com/en/help-topic/by-which-criteria-are-the-trends-evaluated/'
    }
}
